import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconFilterSvg } from "./IconFilterSvg.mjs";
const IconFilter = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconFilterSvg, ...svgProps }) });
export {
  IconFilter
};
